import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './LiveIndices.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function LiveIndices(props) {
    const [currentPage, setCurrentPage] = useState(1);
    let optionInfoMarket = "Live Indices";
    let optionTypeComp = "Daily Market Tracker";
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const [data, setData] = useState([])
    const [groupValue, setGroupValue] = useState('BSE')
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    // const [dataGroup, setDataGroup] = useState([]);
    // const [sectorName, setSectorName] = useState('00000001');
    // const [sectorNameNSE, setsectorNameNSE] = useState("00000001");


    let getData, getDataGroup;
    let PageSize = 5;
    useEffect(() => {
        setloadingshow(true);
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "LiveIndices";
            fetch(`${getUrl}/today/-/${groupValue}/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    //console.log(getData, "getDataBSE")
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "LiveIndices";
            fetch(`${getUrl}/today/-/${groupValue}/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getDataNSE")
                })
                .catch((error) => {
                });
        }


    }, [groupValue,])

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    CallTrackApi("Live Indices",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Live Indices</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='gainer-loser-sc'>
                            <div className='gainer-header'>
                                <h2><span>Live Indices</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            <div className='gainer-table-main'>
                                <div className='exchange-right exchange'>
                                    <div className='holidays-inner-select'>
                                        <select onChange={(event) => { setGroupValue(event.target.value); }}>
                                            <option value="BSE" selected>BSE</option>
                                            <option value="NSE">NSE</option>
                                        </select>
                                    </div>
                                </div>
                                {/* <hr className="hrLiveIndices"></hr> */}
                                <div className='exchange-table table-responsive'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left'>Company Name</th>
                                                <th className='text-right'>Current</th>
                                                <th className='text-right'>Prev.Close</th>
                                                <th className='text-right'>High</th>
                                                <th className='text-center'>Low</th>
                                                <th className='text-right'>Change(%)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentTableData && currentTableData.map(
                                                ({ co_name, close_price, LO_52_WK, HI_52_WK, perchg, PrevClose, Volume, co_code, last }) => (
                                                    <tr>
                                                        <td className="text-left">{co_name}</td>
                                                        {(groupValue === "BSE") ? <td className="text-right"> {(close_price != null) ? close_price.toFixed(2) : 0}</td> : <td className="text-right"> {(last != null) ? last.toFixed(2) : 0}</td>}
                                                        <td className='text-right'>{(PrevClose != null) ? PrevClose.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(HI_52_WK != null) ? HI_52_WK.toFixed(2) : 0}</td>
                                                        <td className='text-center'>{(LO_52_WK != null) ? LO_52_WK.toFixed(2) : 0}</td>
                                                        <td><p className="textGreen text-right"><span className={perchg.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {perchg != null ? perchg.toFixed(2) : 0}</span></p></td>
                                                    </tr>
                                                )
                                            )
                                            }
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }


                                </div>
                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default LiveIndices